"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CalculatorSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var CalculatorSVG = function CalculatorSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M26,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2ZM11,26H9a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Zm0-4H9a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Zm0-4H9a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Zm6,8H15a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Zm0-4H15a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Zm0-4H15a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Zm6,8H21a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Zm0-4H21a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Zm0-4H21a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Zm1-5.5a.5.5,0,0,1-.5.5H8.5a.5.5,0,0,1-.5-.5v-6A.5.5,0,0,1,8.5,6h15a.5.5,0,0,1,.5.5Z"
  }));
};
exports.CalculatorSVG = CalculatorSVG;
CalculatorSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(CalculatorSVG);
exports.default = _default;